export default __webpack_public_path__ + "static/media/ubicacion-title.5406a93e.svg";